import { BackednResponse } from "@shared/lib/types";
import { IGetBrandLedgerFacets } from "@shared/lib/types/briefLedger";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BRIEF_LEDGER_FACETS_QUERY_KEY } from "../constants";

export function useGetBriefLedgerFacets(briefId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBrandLedgerFacets>
  >({
    queryKey: [...BRIEF_LEDGER_FACETS_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefLedgerFacets(briefId),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data || {
      billing: [],
      type: [],
      subType: [],
    },
    isFetching: isLoading,
    isError,
  };
}
